@if (loggedIn) {
  @if (checkRouteAndRedirect()) {
    <app-doc-api></app-doc-api>
  } @else {
    @if (accessApp) {
      <app-layout></app-layout>
    } @else {
      <div class="surface-ground flex align-items-center justify-content-center min-h-screen min-w-screen overflow-hidden">
        <div class="flex flex-column align-items-center justify-content-center">
          <div class="custom-login-card">
            <div class="w-full surface-card py-8 px-5 sm:px-8 flex flex-column align-items-center" style="border-radius:53px">
              <div class="grid flex flex-column align-items-center">
                <div class="flex justify-content-center align-items-center bg-orange-500 border-circle"
                  style="width:3.2rem; height:3.2rem;">
                  <i class="text-50 pi pi-fw pi-lock text-2xl"></i>
                </div>
                <h1 class="text-900 font-bold text-4xl lg:text-5xl mb-2">Accès Refusé</h1>
                <span class="text-600 mb-5">Vous n'avez pas les permissions nécessaires. Veuillez contacter les
                  administrateurs.</span>
                <img src="assets/images/asset-access.svg" alt="Access denied" class="mb-5" width="80%">
                <p-button severity="primary">
                  <i class="pi pi-power-off"></i>
                  <span class="pl-2 font-bold link-secondary" (click)="logout()">{{'buttons.logout' | translate}}</span>
                </p-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    }
    <!--for delivery rec2 just comment app-layout and use profile-tmp-->
    <!--  <div class="tmp-container">
        <div class="tmp-centered">
          <app-profile-tmp></app-profile-tmp>
        </div>
      </div> -->
  }
} @else if (loggedIn === false) {
  @if (!checkRouteAndRedirect()) {
    <app-authentication [loggedIn]="loggedIn"></app-authentication>
  } @else {
    <app-doc-api></app-doc-api>
  }
}

<!-- <div class="tmp-container">
  <div class="tmp-centered">
    <app-profile-tmp></app-profile-tmp>
  </div>
</div> -->

<p-toast></p-toast>